import moment from "moment/moment";
import Reflux from "reflux";
import database from "../../../../utils/FirebaseController";
import logger from "../../../../utils/LoggerFrontend";
import { IMAGE_TEMPLATES_INFO } from "@talentbait/remotion-templates-talentbait";

const INIT = {
  updateInputProps: {},
  updateCurrentInputProps: {},
  saveEditedCreative: {},
  updateShowPictureEditor: {},
  updateSelectedCreativeKey: {},
  updateTemplateId: {},
  updateTemplateType: {},
  // Called from perfomance editor to notify when an adcreative is deleted in order
  // to delete the corresponding media asset
  // Media Assets
  duplicateMediaAsset: { asyncResult: true },
  updateMediaAsset: { asyncResult: true },
  saveMediaAssets: { asyncResult: true },
  getMediaAssetWithCampaignId: { asyncResult: true },
  getMediaAssetWithAdCreativeId: { asyncResult: true },
  getMediaAssetWithId: { asyncResult: true },
  deleteMediaAssetsByCampaignId: { asyncResult: true },
  generateDefaultMediaAsset: { asyncResult: true }
};

const Actions = Reflux.createActions(INIT);

Actions.updateMediaAsset.listen(function (mediaAssetId, mediaAsset) {
  return database.updateMediaAsset(mediaAssetId, mediaAsset);
});

Actions.saveMediaAssets.listen(function (mediaAssets) {
  return database.saveMediaAssets(mediaAssets).then(this.completed).catch(this.failed);
});

Actions.duplicateMediaAsset.listen(async function (mediaAssetId) {
  const mediaAssetToDuplicate = await database.getMediaAssetWithId(mediaAssetId);
  return database
    .saveMediaAssets([mediaAssetToDuplicate])
    .then((newMediaAssets) => this.completed(newMediaAssets[0]))
    .catch(this.failed);
});

Actions.deleteMediaAssetsByCampaignId.listen(function (campaignId) {
  return database.deleteMediaAssetsByCampaignId(campaignId).then(this.completed).catch(this.failed);
});

Actions.getMediaAssetWithId.listen(function (mediaAssetId) {
  return database.getMediaAssetWithId(mediaAssetId).then(this.completed).catch(this.failed);
});

Actions.generateDefaultMediaAsset.listen(async function (
  backgroundImage = "",
  organizationId = null
) {
  const mediaAsset = {
    templateId: IMAGE_TEMPLATES_INFO.DefaultImage.id,
    inputProps: {
      backgroundImage,
      logo: "",
      orientation: "portrait"
    },
    type: "image",
    createdDate: moment().format(),
    orgaId: organizationId
  };

  const ref = await database.createMediaAsset(mediaAsset).catch((error) => {
    logger.log(
      "error:TemplatePostActions:generateDefaultMediaAsset",
      "unable to save generated media asset",
      { mediaAsset, error }
    );
    this.failed(error);
  });
  if (ref?.id) {
    this.completed(ref.id);
  }
});

Actions.getMediaAssetWithCampaignId.listen(function (campaignId) {
  logger.log(
    "TemplatePostActions:getMediaAssetWithCampaignId",
    "fetching media assets that have been generated for the given campaign ",
    { campaignId }
  );
  return database.getMediaAssetWithCampaignId(campaignId).then(this.completed).catch(this.failed);
});
Actions.getMediaAssetWithAdCreativeId.listen(function (adCreativeId) {
  logger.log(
    "TemplatePostActions:getMediaAssetWithAdCreativeId",
    "fetching media assets that have been generated for the given ad creative ",
    { adCreativeId }
  );
  return database
    .getMediaAssetWithAdCreativeId(adCreativeId)
    .then(this.completed)
    .catch(this.failed);
});

export default Actions;
